// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c82smr{font:var(--ds-font-body,normal 400 14px/20px ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._18zru2gc{padding-inline:var(--ds-space-100,8px)}\n._1rjc1b66{padding-block:var(--ds-space-050,4px)}\n._1e0c1txw{display:flex}\n._2hwxu2gc{margin-right:var(--ds-space-100,8px)}\n._4cvr1h6o{align-items:center}\n._tzy4idpf{opacity:0}\n._16l4kb7n:hover{opacity:1}", ""]);
// Exports
module.exports = exports;
